import { SiteAssetsModule, FeaturesModelInstance } from '../types/becky'
import { createFunctionLibrary } from '../functionLibrary'
import { typedModelFactory } from './helpers/typedModelFactory'
import { getBeckyTopology, protectedTopologyValue, resolveBeckyModel } from './helpers/resolveBeckyModel'
import getPayloadWithErrorPage from '../errorPages/getPayloadWithErrorPage'
import byRefModule from '../byRef'

export const featuresModelFactory = typedModelFactory<FeaturesModelInstance>(require('../carmi/features.carmi'))

const featuresModule: SiteAssetsModule<FeaturesModelInstance> = (moduleContext) => {
	const { httpClient, metricsReporter, topology } = moduleContext
	const funcLib = createFunctionLibrary({
		httpClient,
		metricsReporter,
		mediaRootUrl: protectedTopologyValue(topology.mediaRootUrl),
	})

	return {
		execute: async (payload) => {
			payload = payload.errorPageId ? getPayloadWithErrorPage(payload) : payload
			const beckyTopology = getBeckyTopology(topology, payload)
			const payloadWithResolvedRefs = await byRefModule(moduleContext).execute(payload)
			const beckyModel = await resolveBeckyModel(payloadWithResolvedRefs, beckyTopology)
			const { runAsyncAndReport } = funcLib
			return runAsyncAndReport(
				() => new Promise((done) => featuresModelFactory(beckyModel, { ...funcLib, done })),
				'tb-features-model-calculation'
			)
		},
	}
}

export default featuresModule
